import { useCallback } from 'react';
import { Control, UseFormGetValues, useWatch } from 'react-hook-form';

import { Enum } from '~/data/enums';
import {
  getCountryByLegalEntity,
  useAllLegalEntities,
} from '~/data/legalEntity';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { filterActiveEnumsByCountryAndOrgUnits } from '~/utils/helpers/enum';

type PropsType = {
  control: Control<Form>;
  index: number;
  getValues: UseFormGetValues<Form>;
};

export const useFilterActiveEnumsByFormSelections = (props: PropsType) => {
  const { control, index, getValues } = props;

  // useWatch needed to ensure getValues return up to date values
  useWatch({
    control,
    name: `schedule.${index}.empPosition.fEmpLegalEntity`,
  });

  useWatch({
    control,
    name: `schedule.${index}.empPosition.fInternalPositionUnit`,
  });

  const fEmpLegalEntityValue = getValues(
    // @ts-ignore
    `schedule.${index}.empPosition.fEmpLegalEntity`,
  );

  const fEmpOrgUnitValue = getValues(
    `schedule.${index}.empPosition.fInternalPositionUnit`,
  );

  const { legalEntities } = useAllLegalEntities();

  const filterActiveEnumsByFormSelections = useCallback(
    (enums: Enum[]) => {
      return filterActiveEnumsByCountryAndOrgUnits(
        enums,
        getCountryByLegalEntity(+fEmpLegalEntityValue, legalEntities),
        fEmpOrgUnitValue,
      );
    },
    [fEmpLegalEntityValue, fEmpOrgUnitValue, legalEntities],
  );

  return {
    currentFieldValue: {
      fEmpLegalEntityValue,
      fEmpOrgUnitValue,
    },
    filterActiveEnumsByFormSelections,
  };
};
